import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, eur, fmtDate, STATUS } from "@/lib/api";
import { Shell } from "@/components/Shell";
import { StatusBadge } from "@/components/ui-craft";
import { useT } from "@/i18n";

export default function AdminDashboard() {
  const [reqs, setReqs] = useState([]);
  const [stats, setStats] = useState(null);
  const [filter, setFilter] = useState("");
  const [q, setQ] = useState("");
  const { t } = useT();
  useEffect(() => { api.get("/requests").then((r) => setReqs(r.data)); api.get("/admin/stats").then((r) => setStats(r.data)); }, []);
  const rows = reqs.filter((r) => (!filter || r.status === filter) && (!q || `${r.number} ${r.customer_name} ${r.service_name} ${r.city}`.toLowerCase().includes(q.toLowerCase())));
  const todo = reqs.filter((r) => ["nuova", "sopralluogo_pagato", "preventivo_accettato"].includes(r.status)).length;

  return (
    <Shell wide>
      <div className="flex flex-wrap items-end justify-between gap-4 rise">
        <div><p className="eyebrow">{t("admin.backoffice")}</p><h1 className="mt-2 font-serif text-4xl sm:text-5xl font-bold">{t("admin.requests")}</h1></div>
      </div>
      {stats && (
        <div className="mt-8 grid grid-cols-2 md:grid-cols-5 gap-4" data-testid="admin-stats">
          {[[t("admin.todo"), todo, "text-terracotta"], [t("admin.openQuotes"), stats.open_quotes], [t("admin.activeJobs"), stats.active_jobs], [t("admin.total"), stats.total], [t("admin.revenue"), eur(stats.revenue), "text-forest"]].map(([l, v, c]) => (
            <div key={l} className="card-craft p-5"><div className="text-xs uppercase tracking-wider text-ink/50">{l}</div><div className={`mt-2 font-mono text-2xl font-bold ${c || ""}`}>{v}</div></div>
          ))}
        </div>
      )}
      <div className="mt-8 flex flex-wrap gap-3 items-center">
        <input data-testid="admin-search-input" className="input-craft max-w-xs !py-2" placeholder={t("admin.search")} value={q} onChange={(e) => setQ(e.target.value)} />
        <select data-testid="admin-status-filter" className="input-craft max-w-[240px] !py-2" value={filter} onChange={(e) => setFilter(e.target.value)}>
          <option value="">{t("admin.allStatuses")}</option>
          {Object.keys(STATUS).map((k) => <option key={k} value={k}>{t(`status.${k}`)}</option>)}
        </select>
        <span className="text-xs text-ink/50 font-mono ml-auto">{t("admin.nRequests", { n: rows.length })}</span>
      </div>
      <div className="mt-4 card-craft overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-requests-table">
          <thead><tr className="text-left text-xs uppercase tracking-wider text-ink/50 border-b border-craft">{t("admin.cols").map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-craft/60 hover:bg-linen transition-colors" data-testid={`admin-row-${r.number}`}>
                <td className="px-4 py-3 font-mono text-xs">{r.number}</td>
                <td className="px-4 py-3 font-medium">{r.customer_name}</td>
                <td className="px-4 py-3">{r.service_name}</td>
                <td className="px-4 py-3 text-ink/60">{r.city}</td>
                <td className="px-4 py-3 text-xs">{r.path === "inspection" ? t("admin.inspection") : t("admin.remote")}</td>
                <td className="px-4 py-3"><StatusBadge status={r.status} /></td>
                <td className="px-4 py-3 text-ink/60">{r.assigned_name || "—"}</td>
                <td className="px-4 py-3 font-mono text-xs">{fmtDate(r.scheduled_date || r.inspection_date || r.created_at)}</td>
                <td className="px-4 py-3 text-right"><Link to={`/admin/richieste/${r.id}`} className="btn-secondary !py-1.5 !px-4 text-xs" data-testid={`admin-open-${r.number}`}>{t("admin.manage")}</Link></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={9} className="px-4 py-10 text-center text-ink/50">{t("admin.none")}</td></tr>}
          </tbody>
        </table>
      </div>
    </Shell>
  );
}
